"use client"

import React from "react"
import useUIStore from "@/shared/stores/ui/store"

const ToastMessage = () => {
  const toast = useUIStore((state) => state.toast)

  if (!toast) return null

  const getToastStyles = (type: "success" | "error" | "info" | "warning") => {
    switch (type) {
      case "success":
        return "bg-[#6B00D7] text-white opacity-70"
      case "error":
        return "bg-[#FF4D4F] text-white opacity-70"
      case "info":
      case "warning":
      default:
        return "bg-gray-400 text-white"
    }
  }

  return (
    <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-[600px] px-4">
      <div className={`${getToastStyles(toast.type)} px-2 py-3 rounded-lg shadow-lg animate-fade-in w-fit mx-auto`}>
        <span className="text-[14px] font-medium text-center whitespace-pre-line">{toast.message}</span>
      </div>
    </div>
  )
}

export default ToastMessage
